import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app.module';
import { environment } from './environments/environment';
import { initAmplitude } from './analytics/amplitude';

// Aurora V1 rebrand. The palette swap is driven entirely by CSS: the shim in
// core/styles/themes/_aurora-v1-shim.scss repoints every --unity-* token this app
// consumes at its --aurora-* counterpart, gated on this attribute.
//
// Set before bootstrapModule so the attribute is present for the first style
// recalculation - doing it in a component constructor would let the Unity palette
// paint first and then visibly snap to Aurora.
//
// The attribute goes on <body>, not <html>: Unity declares its tokens with
// @scope ([unity-light]) { :scope { ... } }, which binds them directly to <body>
// (see index.html). Custom properties only inherit when the element has no
// declaration of its own, so an override on <html> would be shadowed and do nothing.
//
// Compared strictly against 'true' so an unreplaced '#{auroraV1}#' token in
// environment.prod.ts fails closed, matching HasEnvFlagDirective.
if (environment.auroraV1 === 'true') {
    document.body.setAttribute('aurora-v1', '');
}

// Flag-gated Amplitude browser analytics. No-op unless environment.amplitude.enabled is true.
void initAmplitude();

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));